export const SET_COMISSOES = "COMISSOES/SET_COMISSOES";
export const SET_COMISSAO = "COMISSOES/SET_COMISSAO";
export const SET_CONSELHEIROS = "COMISSOES/SET_CONSELHEIROS";
export const SET_PESSOAS_FISICA = "COMISSOES/SET_PESSOAS_FISICA";
export const SET_PAGINATION = "COMISSOES/SET_PAGINATION";
